<template>
  <v-main>
    <v-container fluid>
      <div>
        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/courses"></back-button>
            Upload Courses
          </h5>
        </div>
      </div>
      <div>
        <v-card elevation="6">
          <v-btn text>
            <a
              :href="`${path}sns/samples/SNS_course_exam_courses_16_12_2023_v3.0.xlsx`"
              >Download sample file</a
            >
          </v-btn>
          <v-card-title>
            <!-- <backbutton></backbutton> -->
            Upload Course Data
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-if="crude_courses.length == 0">
                <div
                  v-if="isLoading == true"
                  style="
                    color: green;
                    font-weight: bold;
                    font-size: 16px;
                    margin-top: 10px;
                  "
                >
                  Please Wait... File loading.
                </div>
                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                  multiple
                  @input="handleFileUpload"
                />
                <div
                  v-if="isUploading"
                  style="
                    color: green;
                    font-weight: bold;
                    font-size: 16px;
                    margin-top: 10px;
                  "
                >
                  Uploading file... Please wait.
                </div>
              </v-col>
              <v-col v-else>
                <v-btn
                  color="success"
                  :loading="isProcessing"
                  :disabled="isProcessing"
                  @click="processFile"
                >
                  Process file</v-btn
                >

                &nbsp;
                <v-btn color="error" @click="truncatePendingDocuments">
                  Delete</v-btn
                >
                <div
                  v-if="isProcess"
                  style="
                    color: #007bff;
                    font-weight: bold;
                    font-size: 16px;
                    margin-top: 10px;
                  "
                >
                  Processing file... Please wait.
                </div>
                <div
                  v-if="is_Truncated"
                  style="
                    color: #007bff;
                    font-weight: bold;
                    font-size: 16px;
                    margin-top: 10px;
                  "
                >
                  Deleted file... .
                </div>
              </v-col>
            </v-row>
            <v-row>
              <span style="color: red" v-show="isError">{{ error_msg }} </span>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <br />
      <br />
      <div>
        <v-card elevation="6">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">Sr.No</th>
                  <th class="text-center">Course Name</th>
                  <th class="text-center">Overview</th>
                  <th class="text-center">Duration</th>
                  <th class="text-center">Description</th>
                  <th class="text-center">Master</th>
                  <th class="text-center">Chief Officer</th>
                  <th class="text-center">Second Officer</th>
                  <th class="text-center">Third Officer</th>
                  <th class="text-center">Deck Cadet</th>
                  <th class="text-center">Bosun</th>
                  <th class="text-center">Able Bodied Seaman-1</th>
                  <th class="text-center">Able Bodied Seaman-2</th>
                  <th class="text-center">Ordinary Seaman-1</th>
                  <th class="text-center">Ordinary Seaman-2</th>
                  <th class="text-center">Trainee Ordinary Seaman</th>
                  <th class="text-center">Chief Engineer</th>
                  <th class="text-center">Second Engineer</th>
                  <th class="text-center">Third Engineer</th>
                  <th class="text-center">Fourth Engineer</th>
                  <th class="text-center">Additional Fourth Engineer</th>
                  <th class="text-center">Electro Technical Officer / EO</th>
                  <th class="text-center">Engine Cadet</th>
                  <th class="text-center">Fitter / Welder</th>
                  <th class="text-center">Trainee Fitter / Welder</th>
                  <th class="text-center">Motorman-1</th>
                  <th class="text-center">Motorman-2</th>
                  <th class="text-center">Motorman-3</th>
                  <th class="text-center">Trainee Wiper / Wiper</th>
                  <th class="text-center">Chief Cook</th>
                  <th class="text-center">Trainee General Steward</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(course, at) in crude_courses" :key="`course${at}`">
                  <td class="text-center">{{ at + 1 }}</td>
                  <td class="text-center">{{ course.course_name }}</td>
                  <td class="text-center">{{ course.overview }}</td>
                  <td class="text-center">{{ course.duration }}</td>
                  <td class="text-center">{{ course.description }}</td>
                  <td class="text-center">{{ course.is_master_course }}</td>
                  <td class="text-center">
                    {{ course.is_chief_officer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_second_officer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_third_officer_course }}
                  </td>
                  <td class="text-center">{{ course.is_deck_cadet_course }}</td>
                  <td class="text-center">{{ course.is_bosun_course }}</td>
                  <td class="text-center">
                    {{ course.is_able_bodied_seaman_1_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_able_bodied_seaman_2_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_ordinary_seaman_1_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_ordinary_seaman_2_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_trainee_ordinary_seaman_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_chief_engineer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_second_engineer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_third_engineer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_fourth_engineer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_additional_fourth_engineer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_electro_technical_officer_course }}
                  </td>
                  <td class="text-center">
                    {{ course.is_engine_cadet_course }}
                  </td>
                  <td class="text-center">{{ course.is_fitter_course }}</td>
                  <td class="text-center">
                    {{ course.is_trainee_fitter_course }}
                  </td>
                  <td class="text-center">{{ course.is_motorman_1_course }}</td>
                  <td class="text-center">{{ course.is_motorman_2_course }}</td>
                  <td class="text-center">{{ course.is_motorman_3_course }}</td>
                  <td class="text-center">
                    {{ course.is_trainee_wiper_course }}
                  </td>
                  <td class="text-center">{{ course.is_chief_cook_course }}</td>
                  <td class="text-center">
                    {{ course.is_trainee_general_steward_course }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
// import backbutton from "@/components/backbutton.vue";
export default {
  //   components: { backbutton },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      crude_courses: [],
      isLoading: false,
      is_mail_sent: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      isProcess: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      hardrefresh: false,
      error_msg: "",
      path: "",
    };
  },
  mounted() {
    this.getData();
    this.path = this.mediaUrl;
    console.log("mounted first");
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crude_courses = await axios.get(`/crude_courses`);
      this.crude_courses = crude_courses.data.data;
      console.log(this.crude_courses);
      this.count = crude_courses.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      this.courses = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("courses", this.courses);
      this.changeValue = 100;
      localStorage.setItem("isFileUploaded", "true");

      await axios
        .post("upload_courses", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crude_courses = response.data.data;
          this.isUploading = false; // Hide loading message
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
    },
    async processFile() {
      try {
        this.isProcess = true;
        this.isProcessing = true;
        await axios
          .get(`process_courses`)
          .then(() => {
            this.isProcess = false;
          })
          .catch(() => {
            this.isError = true;
            this.error_msg =
              "Looks like system faced an error while processing the File. Kindly check the file before processing ...";
          });
        await axios.get("truncate_courses");
        this.crude_products = [];
        this.isProcessing = false;
        this.is_Processed = true;
        alert("Processed Successfully");
        this.getData();
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      this.is_Truncated = true;
      await axios.get("truncate_courses");
      alert("Truncated Successfully");
      this.is_Truncated = false;
      this.getData();

      this.crude_products = [];
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 130px !important;
}
</style>
